import { render, staticRenderFns } from "./RankHistoryEdit.vue?vue&type=template&id=019d9c2b&scoped=true&lang=pug&"
import script from "./scripts/RankHistoryEdit.js?vue&type=script&lang=js&"
export * from "./scripts/RankHistoryEdit.js?vue&type=script&lang=js&"
import style0 from "./RankHistoryEdit.vue?vue&type=style&index=0&id=019d9c2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019d9c2b",
  null
  
)

export default component.exports